import { CheckCircleFilled, ExclamationCircleFilled, CloseCircleFilled } from "@ant-design/icons";
import { VerificationStatus } from "./model";

export const VerificationStatusComponent = ({ verificationStatus }) => {
  const getIcon = (verificationStatus) => {
    switch (verificationStatus) {
      case VerificationStatus.pending:
        return <ExclamationCircleFilled style={{ fontSize: "16px", color: "#C38730" }} />;
      case VerificationStatus.successful:
        return <CheckCircleFilled style={{ fontSize: "16px", color: "#49A1AD" }} />;
      case VerificationStatus.failed:
        return <CloseCircleFilled style={{ fontSize: "16px", color: "#B9394F" }} />;
      default:
        return null;
    }
  };

  return <div>{getIcon(verificationStatus)}</div>;
};
